<template>
  <!-- Main content -->
 <section class="content">
   <!-- Info boxes -->
   <div class="row">
     <div class="row">
       <div id="row center-block">
          <div class="col-md-12">
            <div class="box">
              <div class="box-header col-md-12">
                <label for="displayName" class="col-sm-2 control-label">Nome do Usuário</label>
                <div class="col-sm-3">
                  <input type="text" class="form-control" id="displayName" v-model="displayNameNew">
                </div>
                <div class="col-sm-3">
                  <button type="buttom" class="btn" v-on:click="alterarNomeUsuario()">Gravar Nome</button>
                </div>
              </div>
              <div class="box-body col-md-12">
                <div class="col-sm-3">
                  <button type="buttom" class="btn btn-primary" v-on:click="alterarSenhaUsuario()">Redefinir Senha</button>
                </div>
              </div>
            </div>
          </div>
      </div>
     </div>
     <!-- /.col -->
     <!-- fix for small devices only -->
     <div class="clearfix visible-sm-block"></div>
   </div>
   <!-- /.row -->

   <!-- /.row -->

   <!-- Main row -->
   <div class="row">
   <!-- /.row -->
 </div>
 </section>
 <!-- /.content -->
</template>
<script>
import {firebaseApp} from '../../helpers/firebaseApp'

export default {
  name: 'usuario',
  mounted() {
    this.buscarUsuario()
  },
  data () {
    return {
      displayNameNew: ''
    }
  },
  methods: {
    showAlert (titulo, mensagem, tipoMensagem, exibeBotao, textoBotao) {
      // Use sweetalret2
      this.$swal({
        title: titulo,
        text: mensagem,
        type: tipoMensagem,
        showConfirmButton: exibeBotao,
        confirmButtonText: textoBotao
      })
    },
    buscarUsuario: function() {
      this.displayNameNew = this.$store.state.user.displayName
    },
    alterarNomeUsuario: function() {
      var user = firebaseApp.auth().currentUser
      var confirmar = user.updateProfile({
        displayName: this.displayNameNew
      }).then(function() {
        this.$store.commit('SET_USER', firebaseApp.auth().currentUser)
        window.localStorage.setItem('user', JSON.stringify(firebaseApp.auth().currentUser))
        return true
      }).catch(function(error) {
        console.log(error)
        return false
      })
      if (confirmar) {
        this.showAlert('Nome alterado com sucesso!', 'Favor logar novamente para as alterações serem exibidas!', 'info', true, 'Ok')
      } else {
        this.showAlert('Solicitação não atendida!', 'Falha ao alterar o nome!', 'warning', true, 'Ok')
      }
    },
    alterarSenhaUsuario: function() {
      var auth = firebaseApp.auth()
      var emailAddress = this.$store.state.user.email
      var confirmar = auth.sendPasswordResetEmail(emailAddress).then(function() {
        return true
      }).catch(function(error) {
        console.log(error)
        return false
      })
      if (confirmar) {
        this.showAlert('Solicitação efetuada com Sucesso!', 'Email de redefinição de senha enviado para ' + emailAddress, 'info', true, 'Ok')
      } else {
        this.showAlert('Solicitação não atendida!', 'Falha ao enviar email de redefinição de senha para  ' + emailAddress, 'warning', true, 'Ok')
      }
    }
  }
}
</script>

<style>
#notFound {
 padding: 10em;
 color: white;
}
</style>



// WEBPACK FOOTER //
// Usuario.vue?32211d1e